export const API_URL = 'https://api.nollvision.hockey';
export const TOKEN_NAME = 'svhockey_admin_token';
